import { getGoToFairePosCTA } from "./shared";
export var LinkingPosIA = function LinkingPosIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToFairePosCTA;
        return (_getGoToFairePosCTA = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA === void 0 ? void 0 : _getGoToFairePosCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToFairePosCTA2, _getGoToFairePosCTA2$;
        return (_getGoToFairePosCTA2 = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA2 === void 0 ? void 0 : (_getGoToFairePosCTA2$ = _getGoToFairePosCTA2.getLink) === null || _getGoToFairePosCTA2$ === void 0 ? void 0 : _getGoToFairePosCTA2$.call(_getGoToFairePosCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return LINKING_YOUR_POS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_SET_UP_YOUR_POS_INTEGRATION(strictLocalize)];
    }
  };
};
var LINKING_YOUR_POS = function LINKING_YOUR_POS(strictLocalize) {
  return strictLocalize({
    id: "D6ODY0",
    defaultMessage: [{
      "type": 0,
      "value": "Associar o seu PDV"
    }]
  });
};
var TO_SET_UP_YOUR_POS_INTEGRATION = function TO_SET_UP_YOUR_POS_INTEGRATION(strictLocalize) {
  return strictLocalize({
    id: "EoCgJq",
    defaultMessage: [{
      "type": 0,
      "value": "Para configurar a integração do PDV, clique no botão do ícone de utilizador no canto superior direito do portal do revendedor e selecione a opção \"Associar o meu PDV\". Pode ler mais sobre o processo no artigo do Centro de Ajuda. Se precisar de mais ajuda, contacte-nos."
    }]
  });
};